import store from '@/store';

const checkPermission = (el, binding) => {
  const { value } = binding;
  const permissions = store.getters && store.getters.permissions;

  if (value && value instanceof Array && value.length > 0) {
    const requiredPermissions = value;
    const hasPermission = permissions.some(permission => {
      return requiredPermissions.includes(permission);
    });

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  } else {
    throw new Error(`Permissions are required! Example: v-permission="['manage user','manage role permission']"`);
  }
};

export default {
  mounted(el, binding) {
    checkPermission(el, binding);
  },
  updated(el, binding) {
    checkPermission(el, binding);
  },
};
